import { Command, ReviewData } from '../interfaces';

export enum REVIEW_SORT {
    HIGH_LOW = 'HIGH_LOW',
}

/**
 * Sort based on the title. I.e a-z or z-a.
 * @param data a treatment
 * @returns ReviewData[]
 */
export const reviewSort = <T extends ReviewData>(data: T[], keys: keyof typeof REVIEW_SORT) => {
    let result: ReviewData[] = [];
    if (keys === REVIEW_SORT.HIGH_LOW) {
        result = data.sort((a, b) => b.selectedReview.averageRating - a.selectedReview.averageRating);
    }
    return result;
};

export class ReviewSortCommand implements Command {
    isAndFilter() {
        return undefined;
    }

    execute(data: ReviewData[], keys: keyof typeof REVIEW_SORT) {
        return reviewSort(data, REVIEW_SORT[keys]);
    }
}
